// Global styles
export const globalStyles = () => {
	if (document.getElementById('oneform-gti50-style')) return;

	const css = `
		/* --- Specifics --- */

		:root {
			--c-red: #ff0001;
			--c-black: #000000;
			--c-white: #ffffff;
		}
		
		/* --- Remove entrance animation --- */
		main > div > div {
			padding-bottom: 0 !important;
		}
		.content-wrapper > div {
			transform: none !important;
		}

		/* --- Reset screen styles --- */	

		.full-screen > div:first-of-type {
			display: none !important;
		}
		.prev-step-controller {
			display:none !important;
		}
		main,
		.screen-controller {
			background-color: #000000 !important;
			background-size: cover;
			background-position: center;
			background-repeat: no-repeat;
		}
		div[data-cy='NextBestActionV2'] {
			display: none;
		}
		main a:hover {
			transition: 100ms;
			color: var(--c-red) !important;
		}

		/* --- Footer --- */
		.form-controller-wrapper > div:last-child * {
			color: #ffffff !important;
		}
		[class^="footer__StyledFooterBody"] {
			border: 0;
		}

		/* CONSENTIMIENTOS CTAS
		.content-wrapper > div:nth-child(2) > div > div:nth-child(3) div {
			background: #000000 !important;
			position: relative !important;
		} */
		
		/* MAP */
		.lead-inPage-MAP-controller {
		border-left: 1px solid #535353;
		}
		.lead-inPage-MAP-controller .wrapper,
		.lead-inPage-MAP-controller .close-wrapper {
			background: #000000 !important;
		}
		.lead-inPage-MAP-controller button {
			border: 2px solid #ffffff !important;
		}
		.lead-inPage-MAP-controller button:hover,
		.lead-inPage-MAP-controller button:focus,
		.lead-inPage-MAP-controller button:active {
			background-color: #c90010 !important;
			color: #ffffff !important;
			border: 2px solid #c90010 !important;
		}
		@media (min-width: 960px) {
			.lead-inPage-MAP-controller .box-card-wrapper {
				transition: 200ms !important;
				border-width: 2px !important;
			}
			.lead-inPage-MAP-controller .box-card-wrapper:hover {
				border: 2px solid #c90010 !important;
			}
		}
		.lead-inPage-MAP-controller .box-card-wrapper {
			background-color: #000000 !important;
		}
		.lead-inPage-MAP-controller .close-wrapper > button {
			display: none !important;
		}
		.lead-inPage-MAP-controller .filtros-navbar > button {
			display: none !important;
		}

		.mobile-map-wrapper > .filtros-navbar {
			background: black;
		}
		.mobile-map-wrapper > .filtros-navbar > div > button:first-child {
			background: #c90010;
			border-color: #c90010 !important;
		}
		.mobile-map-wrapper > .filtros-navbar > div > button:last-child {
			display: none !important;	
		}

		/* THANK YOU SCREEN */
		.thank-you-wrapper {
			background: var(--c-black);
			height: 100vh;
		}
		.thank-you-wrapper > .full-screen > .content-wrapper {
			display: flex !important;
		}
		.thank-you-wrapper *:not(button>span) {
			color: #ffffff !important
		}
		.thank-you-wrapper > .full-screen > .content-wrapper > div > div {
			display: flex;
			flex-direction: column;
			align-items: center;
		}
		.thank-you-wrapper > .full-screen > .content-wrapper > div > div svg {
			width: 40px;
			height: 40px;
		}
	`;

	const style = document.createElement('style');
	style.id = 'oneform-gti50-style';
	style.innerHTML = css;
	document.head.appendChild(style);
};
